import { Typography, Box, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { SimCardDownload } from '@mui/icons-material';
import { getInvoiceSendingPdfByUrl } from 'src/shared/services/invoiceService';
import { useState } from 'react';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { InvoiceEvent } from '../models/invoiceEvent';

type InvoiceEventsDetailsProps = {
  events: InvoiceEvent[];
};

const getEventColor = (typeName: string | undefined): string => {
  if (!typeName) return '#9e9e9e';
  const lower = typeName.toLowerCase();
  if (lower.includes('misslyckad')) return '#f44336';
  if (lower.includes('betalning')) return '#00af83';
  if (lower.includes('utskick')) return '#2196f3';
  return '#9e9e9e';
};

const InvoiceEventsDetails = (props: InvoiceEventsDetailsProps) => {
  const { events } = props;
  const { t } = useTranslation(['invoice']);
  const [PDFLoading, setPDFLoading] = useState(false);

  const downloadInvoiceSendingPdf = async (link: string, date: Date) => {
    setPDFLoading(true);
    try {
      await getInvoiceSendingPdfByUrl(link)
        .then(
          (response) =>
            new Blob([response.data], {
              type: 'application/pdf',
            }),
        )
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `faktura_${date}.pdf`;
          a.click();
          a.remove();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            setPDFLoading(false);
          }, 100);
        });
    } catch (err) {
      setPDFLoading(false);
    }
  };

  const sorted = [...events].sort((a, b) => dayjs(b.createdAt).diff(dayjs(a.createdAt)));

  return (
    <ContentSection header={t('invoice:events')}>
      {sorted.map((event, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={index} sx={{ display: 'flex', gap: 1.5, py: 1.25, borderBottom: (thm) => `1px solid ${thm.palette.divider}` }}>
          <Box sx={{ display: 'flex', alignItems: 'center', alignSelf: 'stretch' }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: getEventColor(event.typeName), flexShrink: 0 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box display='flex' alignItems='center' justifyContent='space-between'>
              <Typography variant='body2' sx={{ fontWeight: 500 }}>
                {event.name}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1, flexShrink: 0 }}>
                <Typography variant='caption' color='text.secondary' sx={{ whiteSpace: 'nowrap' }}>
                  {dayjs(event.createdAt).format('YYYY-MM-DD')}
                </Typography>
                {event.url && (
                  <IconButton
                    color='primary'
                    onClick={() => downloadInvoiceSendingPdf(event.url, event.createdAt)}
                    disabled={PDFLoading}
                    size='small'
                  >
                    <SimCardDownload fontSize='small' />
                  </IconButton>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </ContentSection>
  );
};

export default InvoiceEventsDetails;
